import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Solutions from "./pages/Solutions";
import SolutionSolaire from "./pages/SolutionSolaire";
import SolutionChauffage from "./pages/SolutionChauffage";
import SolutionIsolation from "./pages/SolutionIsolation";
import QuoteForm from "./pages/QuoteForm";
import Contact from "./pages/Contact";
// Admin pages
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminQuotes from "./pages/admin/AdminQuotes";
import AdminContacts from "./pages/admin/AdminContacts";
// CMS Admin pages
import CMSHomepage from "./pages/admin/CMSHomepage";
import CMSSolutions from "./pages/admin/CMSSolutions";
import CMSProjects from "./pages/admin/CMSProjects";
import CMSFAQ from "./pages/admin/CMSFAQ";
import CMSCertifications from "./pages/admin/CMSCertifications";

const Layout = ({ children }) => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  
  return (
    <>
      {!isAdminRoute && <Navbar />}
      {children}
      {!isAdminRoute && <Footer />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<Home />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/solutions/solaire" element={<SolutionSolaire />} />
            <Route path="/solutions/chauffage" element={<SolutionChauffage />} />
            <Route path="/solutions/isolation" element={<SolutionIsolation />} />
            <Route path="/devis" element={<QuoteForm />} />
            <Route path="/contact" element={<Contact />} />
            
            {/* Admin routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/quotes" element={<AdminQuotes />} />
            <Route path="/admin/contacts" element={<AdminContacts />} />
            
            {/* CMS Admin routes */}
            <Route path="/admin/cms/homepage" element={<CMSHomepage />} />
            <Route path="/admin/cms/solutions" element={<CMSSolutions />} />
            <Route path="/admin/cms/projects" element={<CMSProjects />} />
            <Route path="/admin/cms/faq" element={<CMSFAQ />} />
            <Route path="/admin/cms/certifications" element={<CMSCertifications />} />
          </Routes>
        </Layout>
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
